











































































































































import { Component, Vue } from 'vue-property-decorator';
import ProductCodeSearchTable from '@/components/search/ProductCodeSearchTable.vue';
import { Action } from 'vuex-class';
import AppLoading from '@/components/AppLoading.vue';
import ViewSearchDialog from '@/components/search/ViewSearchDialog.vue';
import DatabaseOverviewDialog from './DatabaseOverviewDialog.vue';
import { countWords } from '@/helpers/wordCountHelper';
import { SearchConstants } from '@/enums/SearchConstants';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';

@Component({
    name: 'SearchDatabase',
    components: {
        ProductCodeSearchTable,
        AppLoading,
        ViewSearchDialog,
        DatabaseOverviewDialog,
    },
})
export default class SearchDatabase extends Vue {
    @Action('search/searchForResults') protected searchForResults!: ({
        keywords,
    }: {
        keywords: string;
    }) => void;

    protected searchInput: string = '';
    protected isLoading = false;
    private isViewSearchDialogVisible = false;
    private isDatabaseOverviewDialogVisible = false;

    protected navigateToSearchResults() {
        this.$router.push({ name: 'SearchResults' });
    }

    protected onCloseDialog() {
        this.isViewSearchDialogVisible = false;
    }

    protected onDatabaseOverviewCloseDialog() {
        this.isDatabaseOverviewDialogVisible = false;
    }

    protected async onKeywordSearch() {
        if (!this.searchInput) {
            return;
        }
        if (countWords(this.searchInput) > SearchConstants.MaxSearchKeywords) {
            this.showError(SearchConstants.SearchKeywordsError);
            return;
        }
        this.isLoading = true;
        try {
            await this.searchForResults({
                keywords: this.searchInput,
            });
        } catch (e) {
            this.isLoading = false;
            const error = e.response.data.errors[0].detail;
            this.showError(error);
            return;
        }

        this.navigateToSearchResults();
    }

    protected showError(error: string) {
        this.$message.error(error);
    }

    protected get activeProductGroupTotalItems() {
        const type = this.$store.getters['user/activeProductGroup'];

        if (type === ProductGroupTypes.Goodwill) {
            return this.$store.getters['search/goodwillTotalItems'] + ' Goodwill';
        }
        if (type === ProductGroupTypes.Trademark) {
            return this.$store.getters['search/trademarkTotalItems']+ ' Trademark';
        }
        if (type === ProductGroupTypes.CustomerRelations) {
            return this.$store.getters['search/customerTotalItems']+ ' Customer';
        }
        if (type === ProductGroupTypes.Technology) {
            return this.$store.getters['search/technologyTotalItems']+ ' Technology';
        }
        if (type === ProductGroupTypes.Software) {
            return this.$store.getters['search/softwareTotalItems']+ ' Software';
        }
        return '0'
    }
}
